import { Form } from '@entities/leadCollector';
import { gql, useQuery } from 'urql';
import { useCallback } from 'react';

export const FORM_QUERY = gql`
  query GetFormById($formId: Int!) {
    getFormById(formId: $formId) {
      id
      name
      bodyForm
      status
      maxExtraAdults
      maxExtraChildren
      createdAt
      updatedAt
      hasGeneratedLinks
    }
  }
`;
export interface FormResponse {
  getFormById: Form;
}

export const useFetchForm = (formId: number) => {
  const [{ data, fetching, error }, executeQuery] = useQuery<FormResponse>({
    query: FORM_QUERY,
    variables: { formId },
    pause: !formId,
    requestPolicy: 'network-only',
  });

  const form = data?.getFormById;

  const refetch = useCallback(() => {
    executeQuery({ requestPolicy: 'network-only' });
  }, [executeQuery]);

  return {
    fetching,
    error,
    form,
    refetch,
  };
};
